export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_FETCHING_SEARCH_RESULTS = 'SET_FETCHING_SEARCH_RESULTS';
export const SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS';
export const SET_SEARCH_VISIBLE = 'SET_SEARCH_VISIBLE';